import I18n from 'I18n';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const OutOfOfficeMessage = ({
  agent
}) => {
  if (!agent.outOfOfficeEndsAt) {
    return null;
  }
  const returnTime = I18n.moment(agent.outOfOfficeEndsAt);
  const format = returnTime.isSame(new Date(), 'day') ? 'LT' : 'short-date';
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "routing-ui.reassignment.statusTypes.OUT_OF_OFFICE",
    options: {
      dateOrTime: /*#__PURE__*/_jsx(FormattedDateTime, {
        type: "userTz",
        value: returnTime.valueOf(),
        format: format
      })
    }
  });
};
OutOfOfficeMessage.displayName = 'OutOfOfficeMessage';
export const AwayOutsideWorkingHoursMessage = () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "routing-ui.reassignment.statusTypes.AWAY_OUTSIDE_WH"
});
AwayOutsideWorkingHoursMessage.displayName = 'AwayOutsideWorkingHoursMessage';
export const AwayMessage = () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "routing-ui.reassignment.statusTypes.AWAY"
});
AwayMessage.displayName = 'AwayMessage';
export const AvailableMessage = () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "routing-ui.reassignment.statusTypes.AVAILABLE"
});
AvailableMessage.displayName = 'AvailableMessage';
export const InactiveMessage = () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "routing-ui.reassignment.statusTypes.INACTIVE"
});
InactiveMessage.displayName = 'InactiveMessage';